import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Checkbox,
  useMediaQuery,
  useTheme,
  IconButton,
  Drawer,
  AppBar,
  Toolbar
} from "@mui/material";
import {
  Search,
  PersonAdd,
  People,
  Info,
  DeviceHub,
  CheckCircle,
  Cancel,
  Business,
  Person,
  Visibility,
  Edit,
  Delete,
  Email,
  Phone,
  Cake,
  Menu as MenuIcon,
  FilterList
} from "@mui/icons-material";
import axios from "axios";
import { CalendarToday } from "@mui/icons-material";
import { Line, Pie } from "react-chartjs-2";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {axiosInstance, localAxiosGet } from "../../../Axios/axios";

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement } from "chart.js";
import { localAxios } from "../../../Axios/axios";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement);

const localizer = momentLocalizer(moment);

export default function HRHomeDashboard({ setSelectedMenu }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.down('lg'));
  
  const [departments, setDepartments] = useState([]);
  const [teams, setTeams] = useState([])
  const [designations, setDesignations] = useState([]);
  const [loadingDesignations, setLoadingDesignations] = useState(false);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dashboardCardDetails, setDashboardCardDetails] = useState({
    totalEmployees: 0,
    attendancePercentage: "0%",
    pendingLeaves: 0
  });
  
  const [userId, setUserId] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const organizationId = localStorage.getItem('organizationId');
   const token = localStorage.getItem("accessToken")
  
  // Mobile drawer state
  const [mobileOpen, setMobileOpen] = useState(false);
  
  useEffect(() => {
    const storedUserId = localStorage.getItem("userId"); 
  
    if (storedUserId) setUserId(storedUserId);    
    
  }, [])
  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavigateToEmployees = () => {
    setSelectedMenu("Employee Management");
  };
  
  const handleNavigateToAttendance = () => {
    setSelectedMenu("Attendance Management")
  }

  const handleNavigateToLeaveManagement =()=>{
    setSelectedMenu("Leave Management")
  }
  
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    joiningDate: "",
    department: "",
    team: "",
    designation: "",
    grade: "",
    status: "Active",
  });
  
  const handleEditEmployee = (employee) => {
    setIsEditMode(true);
    setFormData({
      firstName: employee.first_name || "",
      lastName: employee.last_name || "",
      email: employee.email || "",
      phoneNumber: employee.phone_numger || "",
      dateOfBirth: employee.dob || "",
      joiningDate: employee.doj || "",
      department: employee.department_id || "",
      team: employee.team_id || "",
      designation: employee.designation_id || "",
      status: employee.status === "active" ? "Active" : "InActive",
      isManager: employee.is_manager || false,
      isTeamLead: employee.is_team_lead || false
    })
   
    setFormData(employee);
    setIsDialogOpen(true);
  };
  
  const handleSaveEmployee = () => {
    if (isEditMode) {
      console.log("Updating employee:", formData);
    } else {
      console.log("Adding new employee:", formData);
    }
    setIsDialogOpen(false);
  }
  
  const [searchTerm, setSearchTerm] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [loadingEmployeeData, setLoadingEmployeeData] = useState(false)
  const [filterStatus, setFilterStatus] = useState("all");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  // const fetchEmployeeData = async (org_id) => {
  //   try {
  //     setLoadingEmployeeData(true);
  //     const token = localStorage.getItem('accessToken');
  //     console.log('Fetching employees for organization ID:', org_id);

  //     if (!org_id) {
  //       console.error('Organization ID not found');
  //       return;
  //     }

  //     const response = await axios(localAxiosGet(`organization/getAllEmployeesByOrganizationId?organization_id=${org_id}`, token));
  //     if (response.data && response.data.status === "SUCCESS" && response.data.message && response.data.message.employees) {
  //       const employeesData = response.data.message.employees;
  //       console.log('Extracted employees data:', employeesData);

  //       setEmployeeData(employeesData);
  //     } else {
  //       console.error('Unexpected API response structure:', response.data);
  //       setEmployeeData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching employee data:", error);
  //     setEmployeeData([]);
  //   } finally {
  //     setLoadingEmployeeData(false);
  //   }
  // }; 

  const [events, setEvents] = useState([]);

  // const fetchAttendanceData = async () => {
  //   try {
  //     const response = await fetch("/api/attendance");
  //     const data = await response.json();
  //     const formattedEvents = data.map((event) => ({
  //       ...event,
  //       start: new Date(event.start),
  //       end: new Date(event.end),
  //     }));
  //     setEvents(formattedEvents);
  //   } catch (error) {
  //     console.error("Error fetching attendance data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchAttendanceData();
  //   const interval = setInterval(fetchAttendanceData, 5 * 60 * 1000);
  //   return () => clearInterval(interval);
  // }, []);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const filteredEmployeeData = employeeData.filter((employee) => {
    const name = `${employee.first_name || ''} ${employee.last_name || ''}`.toLowerCase();
    const email = (employee.email || '').toLowerCase();
    const designation = String(employee.designation || '').toLowerCase();
    const status = (employee.status || '').toLowerCase();

    const matchesSearchTerm =
      name.includes(searchTerm.toLowerCase()) ||
      email.includes(searchTerm.toLowerCase()) ||
      designation.includes(searchTerm.toLowerCase());

    const matchesStatus = filterStatus === "all" ||
      (filterStatus === "Active" && status === "active") ||
      (filterStatus === "InActive" && status === "inactive");

    return matchesSearchTerm && matchesStatus;
  });

  useEffect(()=>{
   
   
    fetchdashBoardCardDetails ();
  },[organizationId]);

   const fetchdashBoardCardDetails = async() =>{
    
        try{
          const response = await axiosInstance(localAxiosGet(`/organization/getHrDashboardData?organization_id=${organizationId}`,token))
          if (response.data && response.data.status === "SUCCESS") {
            setDashboardCardDetails(response.data.message.dashboardData);
          }
        }catch(error){
          console.error("Error in fetching the Dashboard card details", error)
        }
    }

  const paginatedEmployeeData = filteredEmployeeData.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  // Responsive font sizes based on screen size
  const getResponsiveFontSize = (large, medium, small) => {
    if (isSmallScreen) return small;
    if (isMediumScreen) return medium;
    return large;
  };

  return (
    <Box sx={{ 
      padding: { xs: 2, sm: 3, md: 4 }, 
      backgroundColor: "#f9f9f9",
      minHeight: '100vh'
    }}>

      {/* Mobile App Bar */}
      {isMediumScreen && (
        <AppBar 
          position="static" 
          sx={{ 
            mb: 2, 
            display: { md: 'none' },
            backgroundColor: '#1565c0'
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography 
              variant="h6" 
              component="div" 
              sx={{ 
                flexGrow: 1,
                fontSize: getResponsiveFontSize('1.25rem', '1.1rem', '1rem')
              }}
            >
              HR Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      <Box 
        display="flex" 
        justifyContent="space-between" 
        alignItems={isSmallScreen ? "flex-start" : "center"} 
        flexDirection={isSmallScreen ? "column" : "row"}
        marginBottom={4}
        gap={isSmallScreen ? 2 : 0}
      >
        {userDetails && (
          <Box
            sx={{
              background: 'linear-gradient(90deg, #1976d2 0%, #64b5f6 100%)',
              borderRadius: '10px',
              padding: { xs: '15px', sm: '20px 25px' },
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              position: 'relative',
              overflow: 'hidden',
              width: isSmallScreen ? '100%' : 'auto'
            }}
          >
           
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                width: 120,
                height: 120,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: -30,
                left: 40,
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
              }}
            />

            <Box display="flex" alignItems="center">
              <Avatar
                sx={{
                  width: { xs: 40, sm: 50 },
                  height: { xs: 40, sm: 50 },
                  bgcolor: '#fff',
                  color: '#1976d2',
                  fontWeight: 'bold',
                  fontSize: { xs: '1rem', sm: '1.2rem' },
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                  mr: 2
                }}
              >
                {userDetails.first_name ? userDetails.first_name.charAt(0).toUpperCase() : ''}
              </Avatar>

              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontWeight: 500,
                    letterSpacing: '0.5px',
                    mb: 0.5,
                    fontSize: getResponsiveFontSize('0.875rem', '0.8rem', '0.75rem')
                  }}
                >
                  {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                </Typography>

                <Typography
                  variant="h4"
                  sx={{
                    color: '#fff',
                    fontWeight: 700,
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    lineHeight: 1.2,
                    fontSize: getResponsiveFontSize('1.5rem', '1.3rem', '1.1rem')
                  }}
                >
                  Welcome back, {userDetails.first_name}!
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
        
        {/* <Box 
          display="flex" 
          gap={2} 
          alignItems="center" 
          flexDirection={isSmallScreen ? "column" : "row"}
          width={isSmallScreen ? "100%" : "auto"}
          mt={isSmallScreen ? 2 : 0}
        >
          <TextField
            placeholder="Quick Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
            }}
            sx={{ 
              backgroundColor: "white", 
              borderRadius: 2, 
              maxWidth: 250,
              width: isSmallScreen ? '100%' : 'auto'
            }}
            size="small"
          />
          <FormControl sx={{ minWidth: 120, width: isSmallScreen ? '100%' : 'auto' }} size="small">
            <InputLabel>Status</InputLabel>
            <Select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              label="Status"
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Full-time">Full-time</MenuItem>
              <MenuItem value="Freelancer">Freelancer</MenuItem>
            </Select>
          </FormControl>
        </Box> */}
      </Box>

      {dashboardCardDetails && (
        <Grid container spacing={2} marginBottom={3}>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ 
              borderRadius: 2, 
              boxShadow: 3, 
              backgroundColor: '#E3F2FD', 
              cursor: "pointer",
              height: '100%'
            }} onClick={handleNavigateToEmployees}>
              <CardContent sx={{ p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography 
                    variant="h6" 
                    fontWeight="bold" 
                    color="#2196F3"
                    fontSize={getResponsiveFontSize('1rem', '0.9rem', '0.8rem')}
                  >
                    Total Employees
                  </Typography>
                  <People sx={{ fontSize: getResponsiveFontSize(40, 35, 30), color: "#2196F3" }} />
                </Box>
                <Typography 
                  variant="h4" 
                  fontWeight="bold" 
                  color="#333"
                  fontSize={getResponsiveFontSize('2rem', '1.8rem', '1.5rem')}
                >
                  {dashboardCardDetails.totalEmployees}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ 
              borderRadius: 2, 
              boxShadow: 3, 
              backgroundColor: '#FFF3E0', 
              cursor: "pointer",
              height: '100%'
            }} onClick={handleNavigateToAttendance}>
              <CardContent sx={{ p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography 
                    variant="h6" 
                    fontWeight="bold" 
                    color="#FF9800"
                    fontSize={getResponsiveFontSize('1rem', '0.9rem', '0.8rem')}
                  >
                    Attendance Overview
                  </Typography>
                  <Info sx={{ fontSize: getResponsiveFontSize(40, 35, 30), color: "#FF9800" }} />
                </Box>
                <Typography 
                  variant="h4" 
                  fontWeight="bold" 
                  color="#333"
                  fontSize={getResponsiveFontSize('2rem', '1.8rem', '1.5rem')}
                >
                  {dashboardCardDetails.attendancePercentage}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ 
              borderRadius: 2, 
              boxShadow: 3, 
              backgroundColor: '#E8F5E9', 
              cursor:'pointer',
              height: '100%'
            }} onClick={handleNavigateToLeaveManagement}>
              <CardContent sx={{ p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" >
                  <Typography 
                    variant="h6" 
                    fontWeight="bold" 
                    color="#4CAF50"
                    fontSize={getResponsiveFontSize('1rem', '0.9rem', '0.8rem')}
                  >
                    Leave Requests
                  </Typography>
                  <CalendarToday sx={{ fontSize: getResponsiveFontSize(40, 35, 30), color: "#4CAF50" }} />
                </Box>
                <Typography 
                  variant="h4" 
                  fontWeight="bold" 
                  color="#333"
                  fontSize={getResponsiveFontSize('2rem', '1.8rem', '1.5rem')}
                >
                  {dashboardCardDetails.pendingLeaves}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* <Box marginTop={4}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <People sx={{ color: "#2196F3", fontSize: getResponsiveFontSize(30, 25, 20) }} />
          <Typography 
            variant="h6" 
            fontWeight="bold" 
            color="#2196F3"
            fontSize={getResponsiveFontSize('1.25rem', '1.1rem', '1rem')}
          >
            All Employees
          </Typography>
        </Box>
        
        <TableContainer 
          component={Paper} 
          sx={{
            maxHeight: 400,
            overflowX: "auto",
            border: "2px solid #2196F3",
            borderRadius: 3,
            '& th': {
              backgroundColor: '#E3F2FD',
              fontWeight: 'bold',
              fontSize: getResponsiveFontSize('1rem', '0.9rem', '0.8rem'),
              py: 1,
              px: 1
            },
            '& td': {
              fontSize: getResponsiveFontSize('0.875rem', '0.8rem', '0.75rem'),
              py: 1,
              px: 1
            },
            '& tr:nth-of-type(odd)': {
              backgroundColor: '#f5f5f5',
              '&:hover': {
                backgroundColor: '#e0e0e0'
              }
            },
            '& tr:hover': {
              backgroundColor: '#eeeeee !important'
            }
          }}
        >
          <Table stickyHeader size={isSmallScreen ? "small" : "medium"}>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Email</TableCell>
                <TableCell>Designation</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedEmployeeData.map((employee) => (
                <TableRow key={employee.id} hover>
                  <TableCell sx={{ fontWeight: '500' }}>{employee.id}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <Avatar sx={{
                        marginRight: 1,
                        width: { xs: 30, sm: 40 },
                        height: { xs: 30, sm: 40 },
                        bgcolor: employee.status && employee.status.toLowerCase() === "active" ? '#4CAF50' : '#FF9800',
                        fontWeight: 'bold',
                        fontSize: getResponsiveFontSize('0.875rem', '0.8rem', '0.7rem')
                      }}>
                        {employee.first_name ? employee.first_name.charAt(0) : '?'}
                      </Avatar>
                      <Box>
                        <Typography 
                          sx={{ 
                            fontWeight: 500,
                            fontSize: getResponsiveFontSize('0.875rem', '0.8rem', '0.75rem')
                          }}
                        >
                          {`${employee.first_name || ''} ${employee.last_name || ''}`}
                        </Typography>
                        <Typography 
                          sx={{ 
                            display: { xs: 'block', sm: 'none' },
                            fontSize: '0.7rem',
                            color: 'text.secondary'
                          }}
                        >
                          {employee.email}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                    {employee.email}
                  </TableCell>
                  <TableCell>
                    {typeof employee.designation === 'number'
                      ? `ID: ${employee.designation}`
                      : employee.designation || 'N/A'}
                  </TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      variant="contained"
                      color={employee.status && employee.status.toLowerCase() === "active" ? "success" : "warning"}
                      sx={{
                        textTransform: "capitalize",
                        fontSize: getResponsiveFontSize('0.75rem', '0.7rem', '0.65rem'),
                        px: 1,
                        '& .MuiButton-startIcon': { 
                          mr: 0.5,
                          '& > svg': {
                            fontSize: getResponsiveFontSize('0.875rem', '0.8rem', '0.75rem')
                          }
                        }
                      }}
                      startIcon={employee.status && employee.status.toLowerCase() === "active" ?
                        <CheckCircle /> : <Cancel />
                      }
                    >
                      {employee.status}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        <Box display="flex" justifyContent="center" marginTop={2}>
          <Pagination
            count={Math.ceil(filteredEmployeeData.length / rowsPerPage)}
            page={page}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            size={isSmallScreen ? "small" : "medium"}
            showFirstButton
            showLastButton
            sx={{
              '& .MuiPaginationItem-root': {
                color: '#2196F3',
                fontWeight: '500',
                fontSize: getResponsiveFontSize('0.875rem', '0.8rem', '0.75rem'),
                '&.Mui-selected': {
                  backgroundColor: '#2196F3',
                  color: 'white'
                }
              }
            }}
          />
        </Box>
      </Box> */}
      
      {/* <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isSmallScreen}
      >
        <DialogTitle sx={{ 
          backgroundColor: "#1565c0", 
          color: "#fff",
          fontSize: getResponsiveFontSize('1.25rem', '1.1rem', '1rem'),
          py: 2
        }}>
          {isEditMode ? "Edit Employee" : "Add New Employee"}
        </DialogTitle>
        <DialogContent sx={{ padding: { xs: 2, sm: 3 } }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography 
              variant="h6" 
              color="primary"
              fontSize={getResponsiveFontSize('1.1rem', '1rem', '0.9rem')}
            >
              Personal Information
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="First Name"
                  fullWidth
                  size="small"
                  value={formData.firstName}
                  onChange={(e) =>
                    setFormData({ ...formData, firstName: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Person sx={{ mr: 1, color: "#1565c0", fontSize: '1rem' }} />,
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Last Name"
                  fullWidth
                  size="small"
                  value={formData.lastName}
                  onChange={(e) =>
                    setFormData({ ...formData, lastName: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Person sx={{ mr: 1, color: "#1565c0", fontSize: '1rem' }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  size="small"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Email sx={{ mr: 1, color: "#1565c0", fontSize: '1rem' }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Phone Number"
                  fullWidth
                  size="small"
                  value={formData.phoneNumber}
                  onChange={(e) =>
                    setFormData({ ...formData, phoneNumber: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Phone sx={{ mr: 1, color: "#1565c0", fontSize: '1rem' }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Date of Birth"
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={formData.dateOfBirth}
                  onChange={(e) =>
                    setFormData({ ...formData, dateOfBirth: e.target.value })
                  }
                  InputProps={{
                    startAdornment: <Cake sx={{ mr: 1, color: "#1565c0", fontSize: '1rem' }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Joining Date"
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={formData.joiningDate}
                  onChange={(e) =>
                    setFormData({ ...formData, joiningDate: e.target.value })
                  }
                />
              </Grid>
            </Grid>

            <Typography 
              variant="h6" 
              color="primary"
              fontSize={getResponsiveFontSize('1.1rem', '1rem', '0.9rem')}
            >
              Professional Information
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>Department</InputLabel>
                  <Select
                    value={formData.department}
                    onChange={(e) =>
                      setFormData({ ...formData, department: e.target.value })
                    }
                    label="Department"
                  >
                    <MenuItem value="Engineering">Engineering</MenuItem>
                    <MenuItem value="Marketing">Marketing</MenuItem>
                    <MenuItem value="HR">HR</MenuItem>
                    <MenuItem value="Finance">Finance</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>Team</InputLabel>
                  <Select
                    value={formData.team}
                    onChange={(e) =>
                      setFormData({ ...formData, team: e.target.value })
                    }
                    label="Team"
                  >
                    <MenuItem value="Frontend">Frontend</MenuItem>
                    <MenuItem value="Backend">Backend</MenuItem>
                    <MenuItem value="UI/UX">UI/UX</MenuItem>
                    <MenuItem value="Database">Database</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 1,
                    display: 'flex',
                    alignItems: 'center',
                    borderLeft: formData.isManager ? '4px solid #1565c0' : '4px solid transparent',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: 2,
                      backgroundColor: '#f5f9ff'
                    }
                  }}
                >
                  <Checkbox
                    checked={formData.isManager || false}
                    onChange={(e) =>
                      setFormData({ ...formData, isManager: e.target.checked })
                    }
                    color="primary"
                    sx={{ mr: 1 }}
                    size="small"
                  />
                  <Box>
                    <Typography 
                      variant="body1" 
                      fontWeight={500}
                      fontSize={getResponsiveFontSize('0.875rem', '0.8rem', '0.75rem')}
                    >
                      Is Manager
                    </Typography>
                    <Typography 
                      variant="caption" 
                      color="text.secondary"
                      fontSize={getResponsiveFontSize('0.75rem', '0.7rem', '0.65rem')}
                    >
                      Can manage team members and approve requests
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 1,
                    display: 'flex',
                    alignItems: 'center',
                    borderLeft: formData.isTeamLead ? '4px solid #1565c0' : '4px solid transparent',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: 2,
                      backgroundColor: '#f5f9ff'
                    }
                  }}
                >
                  <Checkbox
                    checked={formData.isTeamLead || false}
                    onChange={(e) =>
                      setFormData({ ...formData, isTeamLead: e.target.checked })
                    }
                    color="primary"
                    sx={{ mr: 1 }}
                    size="small"
                  />
                  <Box>
                    <Typography 
                      variant="body1" 
                      fontWeight={500}
                      fontSize={getResponsiveFontSize('0.875rem', '0.8rem', '0.75rem')}
                    >
                      Is Team Lead
                    </Typography>
                    <Typography 
                      variant="caption" 
                      color="text.secondary"
                      fontSize={getResponsiveFontSize('0.75rem', '0.7rem', '0.65rem')}
                    >
                      Can lead team activities and projects
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>Designation</InputLabel>
                  <Select
                    value={formData.designation}
                    onChange={(e) =>
                      setFormData({ ...formData, designation: e.target.value })
                    }
                    label="Designation"
                  >
                    <MenuItem value="Software Engineer">Software Engineer</MenuItem>
                    <MenuItem value="Senior Developer">Senior Developer</MenuItem>
                    <MenuItem value="Tech Lead">Tech Lead</MenuItem>
                    <MenuItem value="Project Manager">Project Manager</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={formData.status}
                    onChange={(e) =>
                      setFormData({ ...formData, status: e.target.value })
                    }
                    label="Status"
                  >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="InActive">InActive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: 2 }}>
          <Button 
            onClick={() => setIsDialogOpen(false)} 
            variant="outlined" 
            color="error"
            size={isSmallScreen ? "small" : "medium"}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSaveEmployee} 
            variant="contained" 
            color="primary"
            size={isSmallScreen ? "small" : "medium"}
          >
            {isEditMode ? "Save Changes" : "Add Employee"}
          </Button>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
}